<div *ngIf="show.report" id="CustomerReportContent"></div>

<div class="ui-g customer-list">

  <div class="ui-g-12">
    <p-messages [(value)]="errors"></p-messages>
  </div>

  <div class="ui-g-12 ui-lg-6">
    <h1>{{'campaign.customers' | translate}}</h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-plus-circle" iconPos="left" routerLink="/customers-details" label="{{ 'common.add' | translate }} {{ 'common.customer' | translate }}"></button>
    <button pButton type="button" class="k-generic-btn" icon="fa fa-plus-circle" iconPos="left" routerLink="/customer-company" label="{{ 'common.add' | translate }} {{ 'common.company' | translate }}"></button>
  </div>

  <div class="ui-g-12">

    <app-kontable #table data-testid="table" *ngIf="customerPermission"
                  title = "{{ 'common.customers' | translate }}"
                  [columns] = "[
                  { field: 'flg_company', bodyTemplate: isCompanyTemplate, filterTemplate: isCompanyFilter, filterType: customFilter, title: 'customerInfoSheet.type' },
                  'customerCode',
                  { field: 'source_system', title: 'customers.source_system', filterType: customFilter, filterTemplate: sourceSystemFilter },
                  'denominazione', 'sede', 'vat_fiscal_code',
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter },
                  {field: 'card_no', title: 'loyalty.card_no', bodyTemplate: cardnoTemplate, maxFilterChars: maxChars},
                  {field: 'birth_date', title: 'common.birth_date', type: 'date', filterType: dateFilter}
                  ]"
                  [titles] = "['customers.code', 'customers.name_and_surname', 'customerDetail.city', 'customerList.fiscalVat']"
                  [showInfoButton]="customerInfoBtnPermission"
                  [showRecoverButton]="true"
                  [showDetailsButton]="false"
                  [showReport]="false"
                  [service]="customerService"
                  [paginationType]="paginationType"
                  [servicePermissions]="customerPermission"
                  [showDownloadExcelBtn]="customerExportExcelPermission"
                  [(fireNewDataAvailable)]="datasetChange"
                  (onEdit)="editCustomer($event)"
                  (onRemove)="deleteCustomer($event)"
                  (onRecover)="recoverCustomer($event)"
                  (onDownloadExcel)="downloadExcel($event)"
                  [filterBySingleColumn]="!staticTable"
                  [showExtSearch]="true"
                  [extSearchConfigKey]="'extsearch-customer'"
                  (extSearchReq)="sendExtSearchQuery($event)"
                  [extSearchResult]="extSearchResult"
                  [totalRecords]="totalRecords"
                  [additionalRowCommands]="customRowCommands"
                >
      <ng-template #isCompanyTemplate data-testid="isCompanyTemplate" let-row>
        <span *ngIf="row.flg_company === 'S'" class="fa fa-building" title="company"></span>
        <span *ngIf="row.flg_company === 'N'" class="fa fa-user" title="customer"></span>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row>
        <span *ngIf="row.flg_state && row.flg_state !== '0'" class="fa fa-trash-o" title="state"></span>
      </ng-template>

      <ng-template #cardnoTemplate data-testid="cardnoTemplate" let-row>
        <span style="margin-right:5px;" [textContent]="row.card_no"></span>
        <i style="cursor:pointer;" *ngIf="(customerMgPermission && row.card_no)" class="fa fa-barcode" (click)="onClickVisualizzaBarcode(row.card_no)"></i>
      </ng-template>

      <ng-template #isCompanyFilter data-testid="isCompanyFilter" let-col>
        <p-dropdown [options]="listTypeCompany" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
        <p-dropdown [options]="listStates" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #sourceSystemFilter data-testid="sourceSystemFilter" let-col>
        <p-dropdown [options]="listSourceSystem" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #customRowCommands data-testid="customRowCommands" let-row>
        <!-- <p-button *ngIf="customerMgPermission" pTooltip="Storico moduli Cliente" label="" icon="fa fa-address-card-o" styleClass="ui-button-blacklist" (onClick)="onClickStoricoModuli(row)"></p-button> -->

        <!-- Button balances -->
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="565.000000pt"
          height="557.000000pt"
          viewBox="0 0 565.000000 557.000000"
          preserveAspectRatio="xMidYMid meet"
          pTooltip="{{ 'loyalty.balance' | translate }}"
          *ngIf="row.flg_blk_lst !== '1' && reservationPermission"
          (click)="goToCustomerBalance(row)"
          class="button-saldi">
          <g transform="translate(0.000000,557.000000) scale(0.100000,-0.100000)"
          fill="#2b4579" stroke="none">
          <path d="M1692 5493 c-68 -33 -103 -115 -82 -188 7 -22 128 -214 269 -427
          l256 -388 685 0 685 0 256 388 c141 213 262 404 268 425 23 69 -13 153 -80
          187 -37 20 -63 20 -1131 20 -988 0 -1096 -2 -1126 -17z"/>
          <path d="M2025 4081 c-694 -421 -1174 -880 -1519 -1450 -158 -261 -292 -595
          -357 -893 -43 -196 -53 -305 -54 -563 0 -230 2 -257 23 -333 61 -224 201 -420
          399 -562 136 -96 259 -152 448 -203 l80 -22 1720 -3 c1190 -2 1745 0 1803 8
          478 63 880 409 968 836 23 112 15 497 -15 669 -101 585 -341 1085 -757 1575
          -91 107 -341 353 -459 451 -224 187 -440 341 -678 483 l-128 76 -682 -1 -682
          -1 -110 -67z m920 -803 c43 -19 55 -56 55 -166 l0 -99 72 -12 c84 -14 183 -51
          253 -97 49 -31 75 -66 75 -102 0 -19 -161 -183 -198 -201 -19 -10 -32 -8 -80
          16 -57 28 -58 28 -287 31 -217 3 -232 2 -263 -18 -83 -51 -83 -211 0 -264 13
          -8 147 -51 298 -96 151 -45 304 -96 339 -113 82 -40 186 -142 229 -223 136
          -261 27 -577 -243 -705 -33 -16 -75 -31 -92 -34 -18 -3 -49 -7 -68 -10 l-35
          -6 0 -104 c0 -102 -1 -106 -29 -137 l-29 -33 -121 0 c-118 0 -121 1 -148 28
          -27 26 -28 33 -33 140 l-5 112 -50 6 c-111 14 -233 65 -305 126 -65 56 -59 78
          53 184 50 49 100 92 110 95 11 3 45 -6 80 -23 61 -28 64 -28 282 -31 195 -2
          224 -1 254 15 98 51 94 232 -6 276 -21 10 -155 51 -298 93 -301 88 -371 120
          -462 212 -155 157 -194 378 -101 574 77 161 226 271 399 294 l49 7 0 109 c0
          108 0 110 29 139 29 29 31 29 140 29 64 0 121 -5 136 -12z"/>
          </g>
        </svg>
        <!-- Fine Button Balances -->

        <!-- Customer Oblivion Button-->
        <p-button *ngIf="customerOblivionBtnPermission" pTooltip="{{ 'customerOblivion.oblivionCustomer' | translate }}" icon="fa fa-remove" styleClass="ui-button-info" (click)="oblivionCustomer(row.customer_id)">
        </p-button>

      </ng-template>
    </app-kontable>
    <div class="barcodeContainer" style="height: 0;visibility: hidden;">
      <svg id="barcode" style="height: 0;"></svg>
    </div>
  </div>

  <p-dialog header="Record Information" [(visible)]="showInfoModal" [modal]="true" [minWidth]="500" [draggable]="false" [resizable]="false">
    <div *ngIf="showInfoModal">

      <div class="ui-g ui-fluid" *ngIf="userInsertInfo">
        <div class="ui-g-6">
          <label>{{ 'Inserted By: ' }}</label>
          <span>{{ userInsertInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'On: ' }}</label>
          <span>{{ customerModal.insert_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-g ui-fluid" *ngIf="userUpdateInfo">
        <div class="ui-g-6">
          <label>{{ 'Updated By: ' }}</label>
          <span>{{ userUpdateInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'On: ' }}</label>
          <span>{{ customerModal.update_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-g ui-fluid" *ngIf="userDeleteInfo">
        <div class="ui-g-6">
          <label>{{ 'Insert By: ' }}</label>
          <span>{{ userDeleteInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'On: ' }}</label>
          <span>{{ customerModal.delete_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-dialog-footer">
        <button type="button" pButton icon="fa fa-close" (click)="showInfoModal = false" label="Ok"></button>
      </div>
    </div>
  </p-dialog>

  <p-dialog *ngIf="showBarcodeModal" header="Barcode" [(visible)]="showBarcodeModal" [modal]="true" [draggable]="true" position="top" [closable]="true">
    <img [src]="srcBarcode" alt="source Barcode" />
  </p-dialog>

  <!--<p-dialog *ngIf="showUploadModal" header="Customers Modules" [(visible)]="showUploadModal" [modal]="true" [minWidth]="800" [draggable]="true" position="top">
      <app-upload-mg (onCloseModal)="onCloseCustomerModules()" [customerHostId]="customerHostIdModuli"></app-upload-mg>
  </p-dialog>-->

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-list/customer-list.component.html